<template>
  <button @click="inviteDm" class="btn accent_light">
    <span>トークルームの招待を送る</span>
  </button>
</template>

<script>
export default {
  name: "SubmitInvitation",
  methods: {
    inviteDm: function() {
      this.$emit("dispatch-invite-dm", null)
    }
  }
}
</script>
